import { render, staticRenderFns } from "./UnsolicitedNpcEffect.vue?vue&type=template&id=b7080324&scoped=true&"
import script from "./UnsolicitedNpcEffect.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedNpcEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7080324",
  null
  
)

export default component.exports